var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"content",staticClass:"page-box"},[_c('div',{staticClass:"page-box-con"},[_c('div',{ref:"mainRight",staticClass:"main-right"},[_c('div',{staticClass:"right-con"},[_c('keep-alive',[_c('router-view')],1)],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }